export function AppFooter() {
    return (
        <footer className="flex h-4 shrink-0 items-center justify-center border-t border-border/50 bg-background px-4 text-[8px] text-muted-foreground/30 select-none">
            © {new Date().getFullYear()} Fowlguard INC
        </footer>
    );
}
